export default __webpack_public_path__ + "ff9572e6d3b563fc377cf1bc5df7baf9.svg";